import TYPES from '../../types';

// Domain
import { OperationEntity } from '../../domain/entities/operation-entity';
import { OperationRepository } from '../../domain/repository/operation-repository';
import { StateManager } from '../../domain/state/state-manager';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Query from '@/modules/shared/domain/use-cases/query';

@Injectable()
export default class SearchOperationsQuery extends Query<Promise<Array<OperationEntity>>> {
  @Inject(TYPES.CATALOG_KUSPIT_OPERATION_STATE_MANAGER)
  private readonly state_manager!: StateManager;

  @Inject(TYPES.CATALOG_KUSPIT_OPERATION_REPOSITORY)
  private readonly repository!: OperationRepository

  internalExecute(): Promise<Array<OperationEntity>> {
    return new Promise((resolve, reject) => {
      if (!this.state_manager.state.loaded) {
        this.repository.execute()
          .then((items) => {
            this.state_manager.patch({ items, loaded: true });
            resolve(items);
          })
          .catch(reject);
      } else {
        resolve(this.state_manager.state.items);
      }
    });
  }
}
